import { styled } from '@mui/material';

const HighlightedText = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export default HighlightedText;
